import { HttpErrorResponse } from '@angular/common/http';
import { Component, DoCheck, ElementRef, OnInit, TemplateRef, ViewChild, HostListener } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup,ValidationErrors,ValidatorFn,Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { LocaleService, OptimService,ConfigurationService, Popr2Service, Popr2Level } from '@ciam/library';
import { LogPageView } from '@fedex/global-data-layer-client';
import { TranslateService, TranslationChangeEvent } from '@ngx-translate/core';
import { isEqual } from 'lodash';
import { Observable, Subject, of, take } from 'rxjs';
import { defaultIfEmpty, filter, finalize, switchMap, takeUntil, tap } from 'rxjs/operators';
import { LoginInfoService } from 'src/app/services/login-info/login-info.service';
import { PendingEditsComponent } from 'src/app/shared/components/pending-edits/pending-edits.component';
import { PoprService } from 'src/app/shared/components/popr/popr.service';
import { GdlService } from 'src/app/shared/services/gdl-service/gdl.service';
import { SharedService } from 'src/app/shared/services/shared-service/shared.service';
import { PoprPriority } from '../../shared/components/popr/popr-priority.enum';
import { TwoFactorComponent } from '../../shared/components/two-factor/two-factor.component';

import { APIResponse, UserProfile } from '../../shared/models/LoginInfoResponse';
import { LoginValidationService } from './login-validation.service';
import { CanDeactivateGuard } from 'src/app/shared/guards/can-deactivate.guard';
import { TwoStepverificationComponent } from './two-stepverification/two-stepverification.component';
import { ProfileEditService } from '../profile-edit/profile-edit.service';
import { StepUpComponent } from 'src/app/features/step-up/step-up.component';
import { StepUpService } from 'src/app/features/step-up/step-up.service';

export enum PARAMS {
  MOCK = 'mock',
  EMAIL_AS_USERID = 'mockemailasuserid',
}

@LogPageView({ page: 'loginsecurity' })
@Component({
  selector: 'wpro-login',
  templateUrl: './login.component.html',
  standalone: false
})
export class LoginComponent implements OnInit, DoCheck/*, CanLeave*/ {
  private readonly ERROR_CODE_400 = 400;
  private readonly MIN_LENGTH_UID = 6;
  private readonly MAX_LENGTH_UID_PASSWORD = 35;
  private readonly MAX_LENGTH_EMAIL_UID = 80;
  private readonly TIMEOUT_VAL = 15000;
  editFlag = false;
  userId: string;
  loginEditForm: UntypedFormGroup;
  userProfile: UserProfile;
  isEmailAsUserId = false;
  toastFlag = false;
  errorFlag = false;
  isPasswordShow = {
    showoldPassword: false,
    showNewPassword: false,
    showReTypePassword: false
  };
  valueChanged = true;
  toggleElement = false;
  public errorCode: string;
  errorInfo: any;
  errorNotificationBoolean: boolean;
  messageFlag: string;
  showEmailAsUserId: boolean = false;
  queryParams: any;
  private _isAPIFailLoginScreen = false;
  /**
   * App-level guard for the "system is unavailable" screen.
   *
   * Once the user profile has successfully loaded, the login screen is usable
   * and must NOT be downgraded to the failure state by a later / ancillary API
   * error (e.g. roleandstatus or recipients getting aborted or timing out a few
   * seconds after render). Any attempt to set this `true` after `userProfile`
   * exists is ignored; setting it `false` (self-heal) always works.
   */
  get isAPIFailLoginScreen(): boolean {
    return this._isAPIFailLoginScreen;
  }
  set isAPIFailLoginScreen(value: boolean) {
    if (value && this.userProfile) {
      return;
    }
    this._isAPIFailLoginScreen = value;
  }
  isDecoupleDeviceMgmt = false;
  /* TODO: Comment out/Remove below variable once Email As User ID feature is turned on */
  isUserIdNotEditable = false;
  gdlFormView = 'form';
  gdlViewCategory = 'view';
  gdlBackCategory = 'back';
  gdlServerType = 'server';
  gdlUiType = 'validation';
  gdlFormName = 'wpro-loginsecurity-edit';
  gdlContextPutType = 'PUT';
  gdlContextGetType = 'GET';
  gdlFormSubmit = 'submit';
  loginEditOriginal: any;
  updatedEditFormVal: any;
  gdlTimeout = 100;
  isFormSubmit = false;
  maxUserIdLength = 35;
  minPassLengthLegacy: any;
  minPassLengthLegacySix: number;
  minPassRuleMsg: any;
  minPassLengthTwelve: number;
  maxLengthNew: number;
  minPassErrorMsg: any;
  minMaxPassRuleMsg: any;
  maxPassLength: number;
  maxPassLengthLegacy: number;
  hasInteractedWithNewPassword: boolean = false;
  isFdx_user: boolean = true;

  @ViewChild('twoFactorElevationFailure', { read: TemplateRef })
  twoFactorFailureTemplate!: TemplateRef<any>;
  @ViewChild('userIdError') userIdError: ElementRef;
  @ViewChild('oldPasswordError') oldPasswordError: ElementRef;
  @ViewChild('newPasswordError') newPasswordError: ElementRef;
  @ViewChild('reTypePasswordMismatchError') reTypePasswordMismatchError: ElementRef;
  @ViewChild('reTypePasswordRequired') reTypePasswordRequired: ElementRef;
  @ViewChild(TwoStepverificationComponent) twoStepverificationComponent: TwoStepverificationComponent;

  failureError: HttpErrorResponse;
  isLoginEdit = true;
  twosv = false;
  isTwoFAEnabled = false;
  isAdaptiveMfa = false;

  private destroy$ = new Subject<void>();
  constructor(
    private _translateService: TranslateService,
    private activatedRoute: ActivatedRoute,
    private config: ConfigurationService,
    private credentialService: LoginValidationService,
    private fb: UntypedFormBuilder,
    private optimService: OptimService,
    public localeService: LocaleService,
    public loginInfoService: LoginInfoService,
    public loginService: LoginInfoService,
    public sharedService: SharedService,
    private poprService: PoprService,
    private gdlService: GdlService,
    private router: Router,
    private popr2Service: Popr2Service,
    private profileEditService: ProfileEditService,
    private stepUpService: StepUpService
  ) {
    this.twosv = this.router.getCurrentNavigation()?.extras?.state?.twosv ?? false;
    this.getLoginValidateInfo();
    this.getUserInfo();
    this.getRoleAndStatus();
    this.checkRecipientAPIStatus();
    this.maxPassLength= this.config.select<number>('password.maxLength') as number;
    this.maxPassLengthLegacy= this.config.select<number>('password.maxLengthLegacy') as number;
  }
  ngOnInit(): void {
    if (!this.twosv) {
      this.twosv = JSON.parse(sessionStorage.getItem('wlgn-2sv')) ?? false;
      sessionStorage.removeItem('wlgn-2sv');
    }
    this.updateAdaptiveMfaFlag(this.sharedService.apiResponse?.output?.userProfile);
    this.sharedService.selectedExternalRoute$.pipe(takeUntil(this.destroy$)).subscribe((data)=>{
    if(data)
      {
        // Skip if not in edit mode or no changes
        if (!this.editFlag || !this.checkLoginInfoUpdated()) {
          this.editFlag = false;
          this.sharedService.selectedExternalRoute.next(''); // Reset
          return;
        }
        
        const poprRef = this.popr2Service.createModal(
          PendingEditsComponent,
          { priority: Popr2Level.NONE, dimension: '.fdx-c-dialog--narrow.fdx-c-dialog--condensed' }
        );
        
        poprRef.open((comp: PendingEditsComponent) => {
          comp.leaveWithoutSave$().pipe(take(1)).subscribe(
            {
              next: (leaveWithoutSaveSub: boolean) => {
                if (leaveWithoutSaveSub) {
                  // User confirmed - clean up and navigate
                  this.sharedService.isLoginMenuClicked = false;
                  this.sharedService.isEditScreen = false;
                  this.editFlag = false;
                  poprRef.close();
                  
                  // Reset the observable to prevent re-triggering
                  this.sharedService.selectedExternalRoute.next('');
                  
                  window.location.href = data;
                  
                } else {
                  // User cancelled - stay on page
                  poprRef.close();
                  // Reset the observable to allow future navigation attempts
                  this.sharedService.selectedExternalRoute.next('');
                }
              },
              complete: () => { 
                poprRef.close();
              }
            });
        });
     }
    });


    window.scroll(0, 0);
    this.minPassLengthLegacySix = this.config.select<number>('password.minlengthLegacy') as number;
    this.minPassLengthTwelve = this.config.select<number>('password.minLength') as number;
    this.maxLengthNew = this.config.select<number>('password.maxLength') as number;

    this._translateService.get(['login.passwordRuleMessageNew', 'login.passwordLimitNew', 'login.passwordLimitLegacySix', 'login.charRange12To25'],
    { minLengthNew : this.minPassLengthTwelve, minLength : this.minPassLengthLegacySix, maxLengthNew: this.maxLengthNew }).subscribe((data: string) => {
      this.minPassRuleMsg = data['login.passwordRuleMessageNew'];
      this.minPassErrorMsg = data['login.passwordLimitNew'];
      this.minPassLengthLegacy = data['login.passwordLimitLegacySix'];
      this.minMaxPassRuleMsg = data['login.charRange12To25'];
    });
    this._translateService.onLangChange.subscribe((event: TranslationChangeEvent)=>{
      this._translateService.get(['login.passwordRuleMessageNew', 'login.passwordLimitNew', 'login.passwordLimitLegacySix', 'login.charRange12To25'],
        { minLengthNew : this.minPassLengthTwelve, minLength : this.minPassLengthLegacySix, maxLengthNew: this.maxLengthNew }).subscribe((data: string) => {
        this.minPassRuleMsg = data['login.passwordRuleMessageNew'];
        this.minPassErrorMsg = data['login.passwordLimitNew'];
        this.minPassLengthLegacy = data['login.passwordLimitLegacySix'];
        this.minMaxPassRuleMsg = data['login.charRange12To25'];
      });
    }); 
    const initialUserInfoTokens: string[] = [];
    this.loginEditForm = this.fb.group({
      emailAsUserId: '',
      userId: ['',  Validators.compose([Validators.required, Validators.minLength(this.MIN_LENGTH_UID), Validators.maxLength(this.MAX_LENGTH_UID_PASSWORD),
        this.credentialService.noSpecialChar()])],
      oldPassword: ['', [Validators.required,
        Validators.minLength(this.minPassLengthLegacySix),
        Validators.maxLength(this.maxPassLengthLegacy)
      ]],
      newPassword: ['', Validators.compose([Validators.required,Validators.minLength(this.minPassLengthTwelve),
        Validators.maxLength(this.maxPassLength),
        this.credentialService.isLengthMet(),
        this.credentialService.isOneNumber(),
        this.credentialService.isUpperandLowercaseMet(),
        this.credentialService.isConsecutiveCharactersMet(),
        this.credentialService.noSpecialChar(),
        this.credentialService.containUserInfoWithForm(initialUserInfoTokens, this.loginEditForm)
      ])],
      reTypePassword: ['', [Validators.required]]
    }, {
      validator: this.credentialService.confirmPasswordMatch('newPassword', 'reTypePassword')
    });

    if (this.sharedService.isPerformanceExecutorOn() && this.sharedService.isEditModeOn()) {
      this.editFlag = true;
    }

    this.isDecoupleDeviceMgmt = (this.config.select<boolean>('deviceMgmtDecoupleFlag') as boolean);

   this.loginEditForm.get('userId')?.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.refreshPasswordUserInfoValidator());

    this.loginEditForm.get('newPassword')?.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.refreshPasswordUserInfoValidator());
  }

  ngDoCheck(): void {
    this.sharedService.isEditScreen = ((this.loginEditForm.dirty || this.loginEditForm.touched) && this.editFlag) ? this.editFlag : false;
  }

  /**
     * Updates the validators for the 'newPassword' form control dynamically.
     * 
     * This method is called whenever the 'userId' or 'emailAsUserId' form controls change,
     * ensuring that the password validation rules are updated to reflect the latest user information.
     * It builds a list of user-related tokens and sets validators to prevent the password from containing
     * easily guessable user information, as well as enforcing other password requirements.
     */
    private refreshPasswordUserInfoValidator(): void {
    const ctrl = this.loginEditForm.get('newPassword');
    if (!ctrl) return;
    const tokens = this.buildUserInfoArray();
    ctrl.setValidators([
      Validators.required,
      Validators.minLength(this.minPassLengthTwelve),
      Validators.maxLength(this.maxPassLength),
      this.credentialService.isLengthMet(),
      this.credentialService.isOneNumber(),
      this.credentialService.isUpperandLowercaseMet(),
      this.credentialService.isConsecutiveCharactersMet(),
      this.credentialService.noSpecialChar(),
      this.credentialService.containUserInfoWithForm(tokens, this.loginEditForm)
    ]);
    ctrl.updateValueAndValidity({ emitEvent: false });
  }

    /**
   * Extracts user-related tokens for password validation.
   * 
   * Tokens extracted include:
   * - First name
   * - Last name
   * - Company name
   * - Email address
   * - Local part of email address (before '@', if length >= 3)
   * - User ID
   * - Local part of user ID (before '@', if length >= 3)
   * 
   * Normalization rules applied:
   * - Converts all tokens to lowercase
   * - Removes all whitespace
   * - Filters out tokens shorter than 3 characters
   * 
   * @returns {string[]} Array of normalized user info tokens
   */
    private buildUserInfoArray(): string[] {
    const list: string[] = [];
    const contact = this.userProfile?.userProfileAddress?.contact;
    if (contact?.personName?.firstName) list.push(contact.personName.firstName);
    if (contact?.personName?.lastName) list.push(contact.personName.lastName);
    if (contact?.companyName) list.push(contact.companyName);
    if (contact?.emailAddress) {
     list.push(contact.emailAddress);
      const local = contact.emailAddress.split('@')[0];
      if (local.length >= 3) list.push(local);
    }
    if (this.userId) {
      list.push(this.userId);
      if (this.userId.includes('@')) {
        const local = this.userId.split('@')[0];
        if (local.length >= 3) list.push(local);
      }
    }
    return list
      .map(v => v.toLowerCase().replace(/\s+/g, ''))
      .filter(v => v.length >= 3);
  }
  // GDL will trigger validation in case of form invalid
  onFocusOut(): any {
    if (this.loginEditForm.invalid) {
      if (this.userIdError && this.userIdError.nativeElement && this.userIdError.nativeElement.innerText !== '') {
        this.gdlService.captureGdlErrorMessages(this.gdlUiType, this.userIdError.nativeElement.innerText, '', 'User Id');
      }
      if (this.oldPasswordError && this.oldPasswordError.nativeElement && this.oldPasswordError.nativeElement.innerText !== '') {
        this.gdlService.captureGdlErrorMessages(this.gdlUiType, this.oldPasswordError.nativeElement.innerText, '', 'Old Password');
      }
      this.capturePasswordValidation();
    }
    // GDL triggers this event when user start interacting the form
    if (this.loginEditForm.touched && this.isLoginEdit) {
      this.isLoginEdit = false;
      this.gdlService.triggerGdlLogEvent(this.gdlFormView, 'start-interaction', { name: this.gdlFormName });
    }
  }

  onNewPasswordInteraction(): void {
    this.hasInteractedWithNewPassword = !this.hasInteractedWithNewPassword;
  }

  capturePasswordValidation(): any {
    if (this.newPasswordError && this.newPasswordError.nativeElement && this.newPasswordError.nativeElement.innerText !== '') {
      this.gdlService.captureGdlErrorMessages(this.gdlUiType, this.newPasswordError.nativeElement.innerText, '', 'New Password');
    }
    if (this.reTypePasswordRequired && this.reTypePasswordRequired.nativeElement && this.reTypePasswordRequired.nativeElement.innerText !== '') {
      this.gdlService.captureGdlErrorMessages(this.gdlUiType, this.reTypePasswordRequired.nativeElement.innerText, '', 'Re-type Password');
    }
    if (this.reTypePasswordMismatchError && this.reTypePasswordMismatchError.nativeElement && this.reTypePasswordMismatchError.nativeElement.innerText !== '') {
      this.gdlService.captureGdlErrorMessages(this.gdlUiType, this.reTypePasswordMismatchError.nativeElement.innerText, '', 'Re-type Password');
    }
  }

  //story no -790366 (check the original login info with updated login info)
  checkLoginInfoUpdated(): boolean {
    this.loginEditOriginal = [{
      emailAsUserId: this.isEmailAsUserId,
      userId: this.userId,
      oldPassword: '',
      newPassword: ''
    }];
    this.updatedEditFormVal = [{
      emailAsUserId: this.loginEditForm.get('emailAsUserId').value,
      userId: this.loginEditForm.get('userId').value,
      oldPassword: this.loginEditForm.touched ? this.loginEditForm.get('oldPassword').value : '',
      newPassword: this.loginEditForm.touched ? this.loginEditForm.get('newPassword').value : ''
    }];
    if (!isEqual(this.loginEditOriginal, this.updatedEditFormVal)) {
      return true;
    }
    return false;
  }

   /**
    * Shows a pending edits modal to confirm the user wants to leave
    */
   canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
   if (!this.editFlag || !this.checkLoginInfoUpdated())
    { return of(!(this.editFlag = false));
    }
    return new Promise<boolean>((resolve, reject)=>{
    const poprRef = this.popr2Service.createModal(
          PendingEditsComponent,
          { priority: Popr2Level.NONE, dimension: '.fdx-c-dialog--narrow.fdx-c-dialog--condensed' }
        );
        poprRef.open((comp: PendingEditsComponent) => {
          comp.leaveWithoutSave$().pipe(take(1)).subscribe(
            { next:(leaveWithoutSaveSub) => {
            if (leaveWithoutSaveSub) {
              this.sharedService.isLoginMenuClicked = false;
              this.sharedService.isEditScreen = false;
              poprRef.close();
              resolve(true);
            } else {
              // User cancelled - stay on current page
              poprRef.close();
              resolve(false);
            }
            }
          });
      });
    });
   }

  getUserInfo(): void {
    this.sharedService.userInfoResponse$.pipe(filter(data => data !== null)).subscribe((data: APIResponse) => {
      if (data.output) {
        // Valid data arrived — clear any earlier "system unavailable" state so a
        // transient empty emission (e.g. a config-race error before config was
        // ready) self-heals once the real 200 response is received.
        this.isAPIFailLoginScreen = false;
        this.userProfile = data.output.userProfile;
        this.userId = this.userProfile.loginInformation.userId;
        this.isEmailAsUserId = this.userProfile.loginInformation.emailAsUserId;
        this.updateAdaptiveMfaFlag(this.userProfile);

        // if (this.isEmailAsUserId) {
        //   this.isUserIdNotEditable = true;
          //this.loginEditForm?.controls.userId.disable();

          /* TODO: Commenting out as per B-1700453 */
          // this.loginEditForm?.controls.userId.setValidators([Validators.required,
          //   Validators.minLength(this.MIN_LENGTH_UID),
          //   Validators.maxLength(this.MAX_LENGTH_EMAIL_UID),
          //   this.credentialService.emailPattern()
          // ]);
        //}
        const userInfo = [];
        const contactInfo = this.userProfile?.userProfileAddress?.contact;
        if (contactInfo?.personName?.firstName) { userInfo.push(contactInfo.personName.firstName?.replace(' ', '').toLowerCase()); }
        if (contactInfo?.personName?.lastName) { userInfo.push(contactInfo.personName.lastName?.replace(' ', '').toLowerCase()); }
        if (contactInfo?.companyName) { userInfo.push(contactInfo.companyName?.replace(' ', '').toLowerCase()); }
        if (contactInfo?.emailAddress) { userInfo.push(contactInfo.emailAddress?.replace(' ', '').toLowerCase()); }
        if (this.userId) { userInfo.push(this.userId?.replace(' ', '').toLowerCase()); }
        this.loginEditForm?.controls.newPassword.addValidators(
          this.credentialService.containUserInfoWithForm(userInfo, this.loginEditForm)
        );
        this.loginEditForm?.controls.newPassword.updateValueAndValidity();
      } else {
        this.isAdaptiveMfa = false;
        /***---- Logic to show 'System not available' error message  ---- ***/
        // Guarded by the isAPIFailLoginScreen setter: if the profile already
        // loaded, a later empty/no-output emission cannot flip the screen to
        // the failure state.
        this.isAPIFailLoginScreen = true;
      }
    });
  }

  private updateAdaptiveMfaFlag(userProfile?: UserProfile): void {
    this.optimService.decide$('wpro_adaptive_mfa').pipe(
      take(1),
      takeUntil(this.destroy$)
    ).subscribe({
      next: (result) => {
        if (result.enabled !== true) {
          this.isAdaptiveMfa = false;
          return;
        }

        this.isAdaptiveMfa = userProfile?.verifiedEmail === true;
      },
      error: () => {
        this.isAdaptiveMfa = false;
      }
    });
  }

  getRoleAndStatus(): any {
    this.loginService.getRoleAndStatus().pipe(
      take(1)
    ).subscribe({
      next: (response: APIResponse) => {
        if (response.output.userType !== 'NON_MANAGED' && response.output.migrationStatus === false) {
          this.showEmailAsUserId = false;
        }
      },
      error: (httpError) => {
        this.failureError = httpError;
       // GDL will triggeers incase of server validation error
        this.gdlService.captureGdlErrorMessages(this.gdlServerType, httpError, this.gdlContextGetType);
        this.isAPIFailLoginScreen = true;
      }
    });
  }
  getLoginValidateInfo(): void {
    this.loginService.getLoginValidateInfo().pipe(
      take(1)
    ).subscribe({
      next: (response: APIResponse) => {
        if (response.output.org !== undefined) {
              const val = "fdx";
              const orgArr = response.output?.org || [];
                this.isFdx_user = orgArr.map((item: string) => item.trim().toLowerCase()).includes(val);
              if(this.isFdx_user) {
                this.isEmailAsUserId = true;
                this.changeUserIdType(this.isEmailAsUserId);
              }
        } else {
              this.isFdx_user = false;
        }
      }
    });
  }
  // Method will check recipients API status
  checkRecipientAPIStatus(): any {
    if (this.sharedService.fdmFlagError) {
      this.isAPIFailLoginScreen = true;
    }
  }

  hideSuccessNotificationPopup(res: boolean, messageFlag: any): void {
    this.toastFlag = res;
    this.messageFlag = messageFlag;
  }

  hideDefaultverifyandTrustedDevice(res: boolean): void { 
    this.isTwoFAEnabled = res;
  }

  hideNotificationPopup(obj: any): any {
    this.errorFlag = obj.flag;
    this.messageFlag = obj.messageFlag;
    this.errorInfo = obj.errorInfo;
  }

  /**
   * Entry point for the Edit / Cancel button.
   *
   * Closing edit (editFlag is true — cancel or after a successful save):
   *   Calls applyEditState(false) immediately.
   *
   * Opening edit (editFlag is false):
   *   1. Calls StepUpService.checkStepUpRequired$() to ask the API.
   *   2a. Step-up required  → opens StepUpComponent modal; on success calls applyEditState(true).
   *   2b. No step-up needed → calls applyEditState(true) directly.
   */
  toggleEdit(): void {
    this.optimService.decide$('wpro_stepup').subscribe(result => {
      if (result.enabled) {
        this.checkStepUpRequired();
      } else {
        this.toggleEditState();
      }
    });
  }

  private checkStepUpRequired(): void {
    /* TODO: Should be updated with FR SDK callback and state. */
    this.stepUpService.checkStepUpRequired$().pipe(
      take(1),
      takeUntil(this.destroy$)
    ).subscribe(requiresStepUp => {
      requiresStepUp ? this.openStepUpModal$() : this.toggleEditState();
    });
  }

  /**
   * Opens StepUpComponent inside a Popr2 modal.
   *
   * registerOnClose is intentionally absent: when the user dismisses via ✕
   * we do nothing (don't enter edit mode). Only a true `verified` emission
   * should open the edit form, preventing mid-close Angular state mutations
   * that cause the HTMLDialogElement.showModal() "not in a Document" error.
   */
  private openStepUpModal$(): void {
    const poprRef = this.popr2Service.createModal(
      StepUpComponent,
      { priority: Popr2Level.NONE, dimension: '.fdx-c-dialog--narrow.fdx-c-dialog--condensed' }
    );

    poprRef.open((comp: StepUpComponent) => {
      comp.verified.pipe(take(1)).subscribe((isVerified: boolean) => {
        poprRef.close();
        if (isVerified) {
          this.toggleEditState();
        }
      });
    });
  }

  /**
   * Single source of truth for entering/leaving edit mode.
   * Keeps the two call-sites (toggleEdit + post-save) DRY and trivially testable
   * by spying on one method.
   *
   * @param active true  → enter edit mode  (shows form, fires 'view' GDL event)
   *               false → leave edit mode  (hides form, fires 'back' GDL event)
   */
  toggleEditState(): void {
    this.editFlag = !this.editFlag;
    this.isLoginEdit = true;
    this.sharedService.isEditScreen = this.editFlag;
    this.hasInteractedWithNewPassword = false;

    // Always clear any pending email change when entering or leaving edit mode
    this.profileEditService.clearEmailChange();
    this.loginEditForm.reset({});
    this.loginEditForm.patchValue({
      emailAsUserId: this.isEmailAsUserId,
      userId: this.userId,
    });
    if (this.isEmailAsUserId) {
      this.changeUserIdType(this.isEmailAsUserId);
    }
    window.scrollTo(0, 0);
    this.errorCode = '';
    const gdlCategory = this.editFlag ? this.gdlViewCategory : this.gdlBackCategory;
    this.gdlService.triggerGdlLogEvent(this.gdlFormView, gdlCategory, { name: this.gdlFormName });
  }

  changeUserIdType(value: boolean): any {
    this.showEmailAsUserId = value;
    const userIdControl = this.loginEditForm.get('userId');
      if(this.showEmailAsUserId)
      {
      /* TODO: Commenting out as per B-1700453 */
      userIdControl.setValidators([Validators.required,
        Validators.minLength(this.MIN_LENGTH_UID),
        Validators.maxLength(this.MAX_LENGTH_EMAIL_UID),
        this.credentialService.emailPattern()
      ]);
      this.loginEditForm.controls.userId.updateValueAndValidity();
      this.maxUserIdLength = this.MAX_LENGTH_EMAIL_UID;
      this.loginEditForm.patchValue({
        userId: this.userProfile?.userProfileAddress?.contact?.emailAddress,
      });
      this.loginEditForm.reset();
      this.loginEditForm.patchValue({
        emailAsUserId: true,
        userId: this.userProfile?.userProfileAddress?.contact?.emailAddress,
      });
      this.valueChanged = true;

    } else{
      this.loginEditForm.controls.userId.enable();
      this.loginEditForm.controls.userId.setValidators([Validators.required,
        Validators.minLength(this.MIN_LENGTH_UID),
        Validators.maxLength(this.MAX_LENGTH_UID_PASSWORD),
        this.credentialService.noSpecialChar()
      ]);
      this.loginEditForm.controls.userId.updateValueAndValidity();
      this.maxUserIdLength = this.MAX_LENGTH_UID_PASSWORD;
      this.loginEditForm.patchValue({ userId: '' });
      if(!this.isEmailAsUserId){
      this.loginEditForm.patchValue({
        userId: this.userProfile.loginInformation.userId,
      });
    }
  }
  }

  // function to hide and show password
  hideShowPass(passwordType: any): void {
    this.isPasswordShow[passwordType] = !this.isPasswordShow[passwordType];
    if (this.isPasswordShow[passwordType]) {
      setTimeout(() => {
        this.isPasswordShow[passwordType] = false;
      }, this.TIMEOUT_VAL);
    }
  }

  saveLoginInfo(isVerifyFlow?: boolean): void {
    const requestPayloadV2 = {
      emailAsUserId: this.loginEditForm.get('emailAsUserId').value,
      userId: this.loginEditForm.get('userId').value,
      oldPassword: this.loginEditForm.get('oldPassword').value,
      newPassword: this.loginEditForm.get('newPassword').value,
      languageCode: this.localeService.solveLocale().language
    };

    const requestPayloadV3 = { ...requestPayloadV2, confirmPassword: this.loginEditForm.get('reTypePassword').value };

    this.optimService.decide$('wpro_2fa_on_edit', { country: `${this.localeService.solveLocale().country}` }).subscribe((result) => {
      const userParams = result.enabled ? requestPayloadV3 : requestPayloadV2;
      this.loginEditForm.disable();
      this.errorCode = '';
      this.loginInfoService.updateLoginInformation(userParams).subscribe(() => {
        this.valueChanged = true;
        this.activateForm();
        this.userId = userParams.userId;
        this.isEmailAsUserId = userParams.emailAsUserId;
        this.toggleEditState();
        this.hideSuccessNotificationPopup(true, 'loginSuccess');
        if (isVerifyFlow && !this.isAdaptiveMfa && this.twoStepverificationComponent) this.twoStepverificationComponent.sendPinRequest();
        this.gdlService.triggerGdlLogEvent(this.gdlFormView, this.gdlFormSubmit, { name: this.gdlFormName });
      }, (httpError) => {
        if(httpError.message === 'elevation failed'){
          httpError.type = 'server';
          httpError.source = 'validation error due to elevation Failed';
        }
        if (isVerifyFlow) this.isTwoFAEnabled = false;
        this.activateForm();
        this.handleError(httpError);
        // GDL will triggeers incase of server validation error
        this.gdlService.captureGdlErrorMessages(this.gdlServerType, httpError, this.gdlContextPutType);
      });
    });
  }

  /**
   * Check if email/userId has changed from the original API response value
   * Only triggers for actual email changes (when emailAsUserId is true)
   * @returns true if email changed, false otherwise
   */
  private checkEmailIdChanged(): boolean {
    const currentUserId = this.loginEditForm.controls['userId'].value;
    const isEmailAsUserId = this.loginEditForm.controls['emailAsUserId'].value;
    
    // Get original email from API response based on emailAsUserId setting
    const originalEmail = isEmailAsUserId 
      ? this.userProfile?.userProfileAddress?.contact?.emailAddress 
      : this.userProfile?.loginInformation?.userId;

    // Only check if emailAsUserId is true (meaning userId field contains email)
    if (isEmailAsUserId && currentUserId !== originalEmail) {
      return true; // Email changed
    }
    
    console.log('[Login] No email change detected');
    return false; // No email change
  }

  /**
   * Entry point for login form submission from UI
   * Checks Optimizely flag and email changes before saving
   */
  onLoginFormSubmit(): void {
    // Check Optimizely flag for email change verification
    this.optimService.decide$('wpro_email_verify', { 
      country: `${this.localeService.solveLocale().country}` 
    }).subscribe((result) => {
      // Check for email change only if flag is enabled
      if (result.enabled && this.checkEmailIdChanged()) {
        // Email changed - notify ProfileEditComponent to trigger verification flow
        const currentUserId = this.loginEditForm.controls['userId'].value;
        const isEmailAsUserId = this.loginEditForm.controls['emailAsUserId'].value;
        const originalEmail = isEmailAsUserId 
          ? this.userProfile?.userProfileAddress?.contact?.emailAddress 
          : this.userProfile?.loginInformation?.userId;
        
        this.profileEditService.notifyEmailChange({
          originalEmailId: originalEmail,
          newEmailId: currentUserId,
          isEmailAsUserId: isEmailAsUserId,
          source: 'login'
        });
        
        return; // Stop submission, verification flow will continue
      }
      
      // Continue with normal submission flow
      this.onLoginInfoSubmit();
    }, () => {
      // If flag lookup fails, continue with normal submission flow
      this.onLoginInfoSubmit();
    });
  }

  onLoginInfoSubmit(): void {
    this.isFormSubmit = true;
    if (this.loginEditForm.valid) {
        if ((!this.isAdaptiveMfa && this.twoStepverificationComponent) && /* Checks if Adaptive Flow or not */
          this.loginEditForm.get('userId').value && /* Checks User ID form field not empty */
          (this.twoStepverificationComponent.deliveryMethod === 'EMAIL' && /* Checks MFA Delivery Method Preference is Email */
            this.loginEditForm.get('userId').value !== this.userId) && /* Checks User ID form value is different from UserInfo API's value */
          this.loginEditForm.get('emailAsUserId').value && /* Checks Email As User ID radio button is checked */
          this.twoStepverificationComponent.twoFaChannelVerify && /* Checks for optimizely '2fa_channel_verify' flag being enabled */
          this.isTwoFAEnabled /* Checks Two-Step Verification toggle button is turned on */
        ) {
          /* Go through Verify Identity flow */
          this.twoStepverificationComponent.revalidateMfa(true);
        } else {
          this.saveLoginInfo();
        }
    } else {
      Object.keys(this.loginEditForm.controls).forEach((key) => {
        this.loginEditForm.controls[key].markAllAsTouched();
        this.toggleElement = true;
        this.activateForm();
      });
      if (this.toggleElement) {
        setTimeout(() => {
          this.onFocusOut();
        },
          this.gdlTimeout);
      }
    }
  }

  continueVerifyFlow(isContinue): void {
     this.saveLoginInfo(isContinue);
  }

  activateForm(): void {
    this.isFormSubmit = false;
    this.loginEditForm.enable();
    //this.disableEmailAsUserIDField();
  }

  disableEmailAsUserIDField(): void {
    if (this.loginEditForm.value.emailAsUserId) {
      this.isUserIdNotEditable = true;
      this.loginEditForm.controls.userId.disable();
    }
  }
  /***---
    * ------- Login API Error Handling  -------
    * For error statusCodes: 400 containing 'USER.REMOTEEXCEPTION.ERROR' / 'USER.SYSTEMUNAVAILABLE.ERROR' and all > 400 - navigate to error popup with mapped error msg.
    * For remaining 400 error codes containing 'USER' or 'PASSWORD'  - display the associated API error msg on UI.
    * --- **/
  handleError(err: HttpErrorResponse): void {
    const errorObj = {
      flag: true,
      messageFlag: '',
      errorInfo: ''
    };
    if (err.status === this.ERROR_CODE_400 && err.error?.errors) {
      this.valueChanged = false;
      const errorCodeValue = err.error?.errors[0].code?.toLowerCase();
      const errorCodes = errorCodeValue.replaceAll('.', '_');
      if (errorCodes === 'usrc_27' ||
        errorCodes === 'info_needed_to_update_profile' ||
        errorCodes === 'remoteexception' ||
        errorCodes === 'systemunavailable') {
        errorObj.errorInfo = err?.error?.errors[0].message;
        errorObj.flag = true;
        errorObj.messageFlag = 'serverError';
        this.hideNotificationPopup(errorObj);

      } else if (errorCodes === 'stepup_auth_expired') {
        // this.elevateAuthority();
        this.elevateAuthority$().subscribe((isElevated) => {
          if (isElevated) {
            this.onLoginInfoSubmit();
            const gdlModal = 'modal';
            const gdlFormName = 'wpro-contactinfo-2fa-verify';
            const gdlConfirm ='confirm';
            this.gdlService.triggerGdlLogEvent(gdlModal,gdlConfirm, { name: gdlFormName });
          }
          else this.poprService.createToast(PoprPriority.ERROR, this.twoFactorFailureTemplate);
        });
      } else if(err.error?.errors[0].code && err.error?.errors[0].code !== '') {
        this.errorCode = err.error?.errors[0].message;
      } else {
        this._translateService.get('errorNotification.genericErrorMessage').subscribe((message: string) => {
          errorObj.errorInfo = message;
          errorObj.flag = true;
          errorObj.messageFlag = 'serverError';
          this.hideNotificationPopup(errorObj);
        });
      }
    } else {
      this.valueChanged = true;
      errorObj.flag = true;
      errorObj.messageFlag = 'systemUnavailable';
      errorObj.errorInfo = err.error?.errors && err.error?.errors.length > 0 ? err.error?.errors[0].message : '';
      this.hideNotificationPopup(errorObj);
    }
  }

  /// To open Iframe modal popup
  elevateAuthority$(): Observable<boolean> {
    const modal = this.poprService.createModal(TwoFactorComponent);
    return modal.component$().pipe(
      switchMap(comp => comp.isElevatedAuthority$()),
      defaultIfEmpty(false),
      finalize(() => modal.close())
    );
  }

  closeLoginEdit(event: boolean): void{
    this.editFlag = event;
    this.sharedService.isEditScreen = event;
  }

  onOldPasswordChange(): void {
    this.valueChanged = true;
  }

  isNewPasswordInvalid(): boolean {
    return this.loginEditForm.controls['newPassword'].errors && this.isDirtyOrTouched();
  }

  hasNewPasswordError(type: string): boolean {
    return this.loginEditForm.controls['newPassword'].errors?.[type] && this.isDirtyOrTouched();
  }
  
  hasNewPasswordSpError(type: string): boolean {
    return (this.loginEditForm.controls['newPassword'].errors?.[type] || 
      this.loginEditForm.controls['newPassword'].errors?.required) && 
      this.isDirtyOrTouched();
  }

  isDirtyOrTouched(): boolean {
    return (this.loginEditForm.controls['newPassword'].dirty ||
      this.loginEditForm.controls['newPassword'].touched);
  }

  hasInputValue(): boolean {
    return !!this.loginEditForm.controls['newPassword'].value;
  }

  getIconKey(type: string, isSpError: boolean): string {
    const errorType = isSpError ? this.hasNewPasswordSpError(type) : this.hasNewPasswordError(type);
    return (!errorType && this.hasInputValue()) ? 'utility_checkmark-fat' : 'utility_cross-fat';
  }
}
